import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import "./CmSearchSuggestionsQAPair.Styles.css";
import { Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { replaceContentEditableText } from "../../utils";
import { Tooltip } from "@mui/material";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import RatingComponent from "../RatingComponentCM/RatingComponent";
import {Tag} from "antd";


export default function CmSearchSuggestionsQAPair(props) {
	const dispatch = useDispatch();
	const { getRatingsDataInSearchSuggestions } = bindActionCreators(Actions, dispatch);
	const searchSuggestionsReducer = useSelector((state) => state.searchSuggestionsCM);
	const domainState = useSelector((state) => state.domain.ratings);
	const { resetRatingsData } = bindActionCreators(Actions, dispatch)
	const userState = useSelector((state) => state.user);
	const [viewExpertScore, setExpertScore] = useState(false);
	const [permission, setPermission] = useState([]);
	const [domains,setDomains] = React.useState([])

	const permissionsCM = userState.roles.filter((obj) => {
		if (obj.roleName === "CM") {
			return obj;
		}
	})
	// let expertScore = permissionsCM.filter((obj) => {
	// 	let newArr = [];
	// 	if (obj.permissions.length > 0) {
	// 		obj.permissions.filter((obj1) => {
	// 			if (obj1.name === 'VIEW_EXPERT_SCORE') {
	// 				newArr.push(obj1);
	// 				return newArr;
	// 			}
	// 		}
	// 		)
	// 		return newArr;
	// 	}
	// })

	let expertScore = permissionsCM.filter((obj) => {
		let newObj = [];
		if (obj.permissions.length > 0) {
			newObj.push(obj.permissions.filter((obj1) => {
				if (obj1.name === 'VIEW_EXPERT_SCORE') {
					return ({ permission: obj1.name })
				}
			}))
		}
		return newObj;
	}
	)

	useEffect(() => {
		if (props.data.domain !== undefined && props.data.domain.includes(',')) {
			const newTag = props.data.domain.split(',')
			setDomains(newTag)
		}
	}, [props.data.domain])

	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<div className="suggestionContainer">
						{
							props.data.questionText !== undefined && props.data.questionText !== '' &&
							<div className="headingContainer">
								<h3>{props.data.questionText}</h3>
							</div>
						}
						{/* <Grid container>
							<Grid item xs={10}>

							</Grid>
						</Grid> */}
						{props.data.answerText === null &&
							<Grid container>
								<Grid item xs={12} padding={1}>
									<Divider variant="inset" />
								</Grid>
							</Grid>}
						<div style={{paddingBottom:'5px',marginLeft:'10px'}}>
							{
								<>
									{/* <span className="suggestionText">
									Suggestion
								</span> */}
									{props.data.domain !== undefined && domains.length === 0
										&& <Tag color={"#878787"} style={{ fontFamily: 'inherit', backgroundColor: '#878787', color: '#fff' }}>
											{props.data.domain}
										</Tag>}
									{
										props.data.domain !== undefined &&
										props.data.domain !== '' &&
										domains.length > 0 &&
										(
										 <Tooltip title={props.data.domain}>
										 <Tag color={"#878787"} style={{ fontFamily: 'inherit', backgroundColor: '#878787', color: '#fff' }}>{`${domains[1]}${`${" "}+${" "}${domains.length - 1}${" "}more`}`}</Tag>
										 </Tooltip>
										)
									}
								</>
							}
						{
							props.data.confidence ?
								<>
									{/* <span className="bestResultText">
									Best Result
								</span> */}
									<Tag color={"#57A13D"} style={{fontFamily:'inherit',backgroundColor:'#57A13D',color:'#fff'}}>
										Best Result
									</Tag>
								</>
								:
								(
									<Tag color={"#FFA500"} style={{backgroundColor:'#FFA500',color:'#fff',fontFamily:'inherit'}}>
										Similar Result
									</Tag>
								)
						}
						{
							props.data.answerStatus === 'accepted' &&
							searchSuggestionsReducer.searchSuggestionDetails !== '' &&
							<>
								{/* <span className="acceptedTextInSearchSuggestions">
									Accepted
								</span> */}
								<Tag color={"#008001"} style={{marginLeft:0,fontFamily:'inherit',backgroundColor:'#008001',color:'#fff'}}>
									Liked
								</Tag>
							</>
						}
							{
							props.data.answerStatus === 'rejected' && 
							<Tag color={"#EF3B24"} style={{fontFamily:'inherit',backgroundColor:'#EF3B24',color:'#fff'}}>Disliked</Tag>
						}
						{
							!props.data.docId &&
							searchSuggestionsReducer.searchSuggestionDetails !== '' &&
							!searchSuggestionsReducer.searchSuggestionDetails.answerable &&
							<>
								{/* <span className="expertSourcedText">
									Expert Sourced
								</span> */}
								<Tag color={"#EB5A29"} style={{marginLeft:0,fontFamily:'inherit',backgroundColor:'#EB5A29',color:'#fff'}}>
									Expert Sourced
								</Tag>
							</>
						}
						{
							props.data.docId &&
							searchSuggestionsReducer.searchSuggestionDetails !== '' &&
							!searchSuggestionsReducer.searchSuggestionDetails.answerable &&
							<>
								{/* <span className="expertSourcedText">
									Doc Sourced
								</span> */}
								<Tag color={"#EB5A29"} style={{marginLeft:0,fontFamily:'inherit',backgroundColor:'#EB5A29',color:'#fff'}}>
									Doc Sourced
								</Tag>
							</>
						}
						{
							<>
								{/* <span className="timestampDate">
									on {moment(props.data.answeredTimestamp).format('MMM DD,YYYY h:mm A')}
								</span> */}
							</>
						}
						</div>
						<div style={{ display: 'flex' }}>
							<div className="expertText">
								Expert&nbsp;
								<span className="expertName">
									{props.data.expertFirstName}{" "}{props.data.expertLastName}
								</span>
							</div>
							{
								props.data.expertScore &&
								<div style={{ fontSize: '12px', color: '#8F8F8F', fontWeight: 'bold' }}>
									<i className="fa fa-star"></i>
									{" "}{props.data.expertScore}/10
								</div>
							}
						</div>
						{
							// props.data.answerStatus !== 'open' &&
							// props.data.answerStatus !== 'rejected' &&
							<>
								<Grid container padding={1}>
									<Grid item xs={12}>
										<Box sx={{ fontWeight: '300', fontSize: '14px', backgroundColor: '#f6f6f6', padding: '10px', wordWrap:'break-word', overflowX:'auto' }}>
											<div dangerouslySetInnerHTML={{
												__html: replaceContentEditableText(props.data.answer),
											}}>
											</div>
											{props.data.url !== undefined &&
												<>
													<div>URL:<a href={props.data.url} target="_blank">{props.data.url}</a></div>
												</>
											}
										</Box>
									</Grid>
								</Grid>
							</>
						}
						{
							props.data.attachments.length > 0 &&
							<Grid container paddingBottom={1}>
								<Grid item xs={12} sm={12}>
									{
										props.data.attachments.map((attachment) => {
											return (
												<>
													<AttachmentBox attachment={attachment} />
												</>
											)
										})
									}
								</Grid>
							</Grid>
						}
						<Grid xs={12} sm={12} md={12} container columns={{ xs: 2,sm:2}} alignItems="baseline"  justifyContent="space-between">
						<Grid padding={1} item>
							{
								props.data.popularityScore &&
								props.data.popularityScore > 0 &&
									<Tooltip title="Number of times this answer was viewed">
										<span className="viewScoreSearch">
											<i className="fa fa-eye" style={{ color: '#7988a2', fontSize: '11px' }}></i>{" "}{props.data.popularityScore}
										</span>
									</Tooltip>
							}
							</Grid>
							<Grid item >
								{searchSuggestionsReducer.ratings !== null && searchSuggestionsReducer.ratings[props.data.docId === undefined ? props.data.originalAnswerUuid : props.data.docId] &&
									<RatingComponent
										id={props.data.docId === undefined ? props.data.originalAnswerUuid : props.data.docId}
										rating={searchSuggestionsReducer.ratings[props.data.docId === undefined ? props.data.originalAnswerUuid : props.data.docId]}
										isDisable={true}
									/>
								}
							</Grid>
						</Grid>
					</div>
					{
						props.index === searchSuggestionsReducer.searchSuggestionDetails.length - 1
						&&
						<>
							<Divider sx={{ color: '#ccc'}} />
							<Box sx={{padding:'32px'}}/>
						</>
					}
				</Grid>
			</Grid>
		</>
	)
}